module.exports = __webpack_public_path__ + "static/media/guide_img2_1_m.af99232a.png";